/*
Copyright (c) 2012-2022 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { FC } from "react"
import { useSelector } from "react-redux"
import { AppState } from "store/store.type"
import { storageHelper } from "utils/storage"
import { useTranslationsMap } from "common/utils/i18n"

interface IProps {}

export const NonEditableMenuAlert: FC<IProps> = () => {
  const { isMartStore } = useSelector((state: AppState) => state?.menu)
  const textMap = useTranslationsMap({
    title: !isMartStore
      ? "menu.alerts.nonEditable.title"
      : "catalogue.alerts.nonEditable.title",
    body: !isMartStore
      ? "menu.alerts.nonEditable.content"
      : "catalogue.alerts.nonEditable.content",
  })

  const [bodyStart, body] = (textMap?.body ?? "").split("<a>")
  const [bodyLink, bodyEnd] = (body ?? "").split("</a>")

  return (
    <div
      css={css`
        padding: 21px 29px;
        background: rgba(0, 165, 207, 0.04);
        border-radius: 8px;
        display: flex;
        flex-direction: row;
      `}
    >
      <div
        css={css`
          height: 61px;
          width: 61px;
          background-color: #c7f1ff;
          border-radius: 50%;
          display: inline-block;
          position: relative;
        `}
      >
        <img
          src={require("./noEdit.svg")}
          alt="noedit-icon"
          css={css`
            position: absolute;
            height: 31.5px;
            width: 31.5px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          `}
        />
      </div>
      <div
        css={css`
          margin-left: 25px;
          display: flex;
          flex-direction: column;
        `}
      >
        <div>
          <span
            css={css`
              font-size: 22px;
            `}
          >
            {textMap.title}
          </span>
        </div>
        <div>
          <span
            css={css`
              font-size: 16px;
              color: #8d8d8d;
            `}
          >
            {bodyStart}
            <a
              css={css`
                color: #00a5cf;
              `}
              href={storageHelper.getTroyHelpCenterUrlV2()}
              target="_blank"
              rel="noreferrer"
            >
              {bodyLink}
            </a>
            {bodyEnd}
          </span>
        </div>
      </div>
    </div>
  )
}
